<template>
	<section class=" bg-main">
		<div class="py-12"></div>
		<div class="vx-row justify-center m-0">
			<div class="vx-col w-full md:w-3/4 lg:w-1/2 xl:w-1/3">
				<vs-alert :active.sync="close" closable v-if="message != null" color="warning" class="mb-4">
					{{message}}
				</vs-alert>
				<forgot-password-form @submit="submit"></forgot-password-form>
			</div>
		</div>
		<div class="py-12"></div>
	</section>
</template>
<script>
import ForgotPasswordForm from './components/ForgotPasswordForm.vue'

export default {
  components: {
    ForgotPasswordForm
  },
  data: () => ({
    close: true,
    email: null,
    message: null
  }),
  methods: {
    submit (email) {
      this.$vs.loading({
        container: '#button-nih',
        type: 'material',
        text: '',
        scale: 0.5
      })
      this.$store.dispatch('auth/forgotPassword', email)
        .then(data => {

          this.$vs.loading.close('#button-nih > .con-vs-loading')
          this.email = email
          this.message = data.message ? data.message : `Link reset password berhasil dikirim ke ${  this.email  } silahkan cek email anda`
        })
        .catch(e => {
          this.$vs.loading.close('#button-nih > .con-vs-loading')
          if (e.response) {
            console.error(e.response)
            if(e.response.data.message && typeof e.response.data.message === 'string') {
              this.$vs.notify({
                title: 'Oops',
                text: e.response.data.message,
                color: 'warning',
                position: 'top-right'
              })
            }
            else {
              e.response.data.map(error => {
                this.$vs.notify({
                  title: 'Oops',
                  text: error,
                  color: 'warning',
                  position: 'top-right'
                })
              })
            }
          }

          return false
        })
    }
  }
}
</script>
<style>
	.bg-main {
		background-image: url('/assets/images/footer/bg.svg');
		background-repeat: no-repeat;
		background-size: cover;
	}
</style>